import { render, staticRenderFns } from "./AvatarStack.vue?vue&type=template&id=f78883dc&scoped=true"
import script from "./AvatarStack.vue?vue&type=script&setup=true&lang=ts"
export * from "./AvatarStack.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AvatarStack.vue?vue&type=style&index=0&id=f78883dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78883dc",
  null
  
)

export default component.exports